import React from 'react'

const TypingIndicator: React.FC = () => {
  return (
    <div className="mx-auto max-w-3xl mt-4">
      <div className="flex justify-start">
        <div className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-200 dark:border-gray-700 rounded-lg px-4 py-3">
          <div className="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TypingIndicator
